import { render, staticRenderFns } from "./Leads_ID.vue?vue&type=template&id=e923dbb0&scoped=true&"
import script from "./Leads_ID.vue?vue&type=script&lang=js&"
export * from "./Leads_ID.vue?vue&type=script&lang=js&"
import style0 from "./Leads_ID.vue?vue&type=style&index=0&id=e923dbb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e923dbb0",
  null
  
)

export default component.exports